import http from './http'

class Serasa {
  approveProtestos (id) {
    return http.post(`/serasa_concentre_query_requests/${id}/approve_protestos`)
  }

  rejectProtestos (id) {
    return http.post(`/serasa_concentre_query_requests/${id}/reject_protestos`)
  }
}

export default new Serasa()



// WEBPACK FOOTER //
// ./src/services/serasa.js